<template>
  <span>
    {{ dir === 'next' ? '»' : '‹' }}
  </span>
</template>

<script setup lang="ts">
defineProps<{
  dir: 'next' | 'back';
}>();
</script>
